export const useAddOrderNumberPrefix = () => {
  const addOrderNumberPrefix = (orderNumber: string) => {
    return `${process.env.b2bOrderPrefix}${orderNumber.padStart(parseInt(process.env.orderNumberLengthLimit), '0')}`;
  };
  return {
    addOrderNumberPrefix,
  };
};
